import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de.json';
import al from './al.json';

i18n.use(initReactI18next).init({
  resources: { de: { translation: de }, al: { translation: al } },
  lng: localStorage.getItem('zq_lang') || 'de',
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
});

export default i18n;
